import { ApiService } from './api.service';
import { SchoolGroupPMAnalysis } from '@/models/school-group/school-group-pm-analysis';

class SchoolGroupPmAnalysisService extends ApiService {
  constructor() {
    super();
  }

  getSchoolGroupPMAnalysis(targetType: number = 1, targetID: number = 1, growingPurpose: number = 1, tagIDs: string = ''): Promise<SchoolGroupPMAnalysis> {
    return this.get(SchoolGroupPMAnalysis, 'schoolGroups/pmAnalysis', {
      targetType,
      targetID,
      growingPurpose,
      tagIDs,
    });
  }
}

export const schoolGroupPMAnalysisService = new SchoolGroupPmAnalysisService();
